import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "nav-link" }
const _hoisted_2 = { class: "title-4 text-grey-900 m-0" }

import { computed, ComputedRef } from 'vue'

  // Translations
  import { useI18n } from 'vue-i18n'
  import { useStore } from 'vuex'
  
export default /*@__PURE__*/_defineComponent({
  __name: 'UserName',
  setup(__props) {

  const { t } = useI18n()

  // Store
  const store = useStore()

  // Computed
  const userName: ComputedRef<string> = computed(() => {
    const { user } = store.state.auth
    if (!user) return ''

    const MAX_USER_LENGTH = 20
    const userName = `${user.first_name} ${user.last_name}`
    return userName.substring(0, MAX_USER_LENGTH)
  })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", _hoisted_2, _toDisplayString(_unref(t)('navbar.greeting')) + " " + _toDisplayString(userName.value), 1)
  ]))
}
}

})